// Generated by Melange

import Big_vendoredJs from "./big_vendored.js";
import * as Caml_exceptions from "melange.js/caml_exceptions.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_exn from "melange.js/js_exn.js";

const Unknown_error = /* @__PURE__ */ Caml_exceptions.create("Big.Unknown_error");

const Div_by_zero = /* @__PURE__ */ Caml_exceptions.create("Big.Div_by_zero");

const Invalid_number = /* @__PURE__ */ Caml_exceptions.create("Big.Invalid_number");

const Invalid_decimal_places = /* @__PURE__ */ Caml_exceptions.create("Big.Invalid_decimal_places");

const Invalid_rounding_mode = /* @__PURE__ */ Caml_exceptions.create("Big.Invalid_rounding_mode");

const No_square_root = /* @__PURE__ */ Caml_exceptions.create("Big.No_square_root");

const Invalid_precision = /* @__PURE__ */ Caml_exceptions.create("Big.Invalid_precision");

function try_wrap(f, js_msg, exn) {
  try {
    return Curry._1(f, undefined);
  }
  catch (raw_e){
    const e = Caml_js_exceptions.internalToOCamlException(raw_e);
    if (e.MEL_EXN_ID === Js__Js_exn.$$Error) {
      const m = e._1.message;
      if (m !== undefined) {
        if (m === js_msg) {
          throw new Caml_js_exceptions.MelangeError(exn.MEL_EXN_ID, exn);
        }
        console.log(m);
        throw new Caml_js_exceptions.MelangeError(Unknown_error, {
              MEL_EXN_ID: Unknown_error
            });
      }
      throw new Caml_js_exceptions.MelangeError(Unknown_error, {
            MEL_EXN_ID: Unknown_error
          });
    }
    throw new Caml_js_exceptions.MelangeError(e.MEL_EXN_ID, e);
  }
}

function fromString(s) {
  return try_wrap((function (param) {
    return new Big_vendoredJs(s);
  }), "[big.js] Invalid number", {
    MEL_EXN_ID: Invalid_number
  });
}

function fromFloat(prim) {
  return new Big_vendoredJs(prim);
}

function fromInt(prim) {
  return new Big_vendoredJs(prim);
}

const bigJsObj = Big_vendoredJs;

function setDP(n) {
  if (n >= 0) {
    bigJsObj.DP = n;
    return;
  }
  throw new Caml_js_exceptions.MelangeError(Invalid_decimal_places, {
        MEL_EXN_ID: Invalid_decimal_places
      });
}

function setRM(n) {
  if (n >= 0 && n <= 3) {
    bigJsObj.RM = n;
    return;
  }
  throw new Caml_js_exceptions.MelangeError(Invalid_rounding_mode, {
        MEL_EXN_ID: Invalid_rounding_mode
      });
}

function setNE(param) {
  bigJsObj.NE = param;
}

function setPE(param) {
  bigJsObj.PE = param;
}

function getDP(param) {
  return bigJsObj.DP;
}

function getRM(param) {
  return bigJsObj.RM;
}

function getNE(param) {
  return bigJsObj.NE;
}

function getPE(param) {
  return bigJsObj.PE;
}

function div(x, y) {
  return try_wrap((function (param) {
    return x.div(y);
  }), "[big.js] Division by zero", {
    MEL_EXN_ID: Div_by_zero
  });
}

function mod_(x, y) {
  return try_wrap((function (param) {
    return x.mod(y);
  }), "[big.js] Division by zero", {
    MEL_EXN_ID: Div_by_zero
  });
}

function sqrt(x) {
  return try_wrap((function (param) {
    return x.sqrt();
  }), "[big.js] No square root", {
    MEL_EXN_ID: No_square_root
  });
}

function toPrecision(x, sd, param) {
  return try_wrap((function (param) {
    return x.toPrecision(sd !== undefined ? Caml_option.valFromOption(sd) : undefined);
  }), "[big.js] Invalid precision", {
    MEL_EXN_ID: Invalid_precision
  });
}

function c(prim) {
  return prim.c;
}

function e(prim) {
  return prim.e;
}

function s(prim) {
  return prim.s;
}

function abs(prim) {
  return prim.abs();
}

function cmp(prim0, prim1) {
  return prim0.cmp(prim1);
}

function eq(prim0, prim1) {
  return prim0.eq(prim1);
}

function gt(prim0, prim1) {
  return prim0.gt(prim1);
}

function gte(prim0, prim1) {
  return prim0.gte(prim1);
}

function lt(prim0, prim1) {
  return prim0.lt(prim1);
}

function lte(prim0, prim1) {
  return prim0.lte(prim1);
}

function minus(prim0, prim1) {
  return prim0.minus(prim1);
}

function plus(prim0, prim1) {
  return prim0.plus(prim1);
}

function pow(prim0, prim1) {
  return prim0.pow(prim1);
}

function round(prim0, prim1, prim2, prim3) {
  return prim0.round(prim1 !== undefined ? Caml_option.valFromOption(prim1) : undefined, prim2 !== undefined ? Caml_option.valFromOption(prim2) : undefined);
}

function times(prim0, prim1) {
  return prim0.times(prim1);
}

function toExponential(prim0, prim1, prim2) {
  return prim0.toExponential(prim1 !== undefined ? Caml_option.valFromOption(prim1) : undefined);
}

function toFixed(prim0, prim1, prim2) {
  return prim0.toFixed(prim1 !== undefined ? Caml_option.valFromOption(prim1) : undefined);
}

function toString(prim) {
  return prim.toString();
}

function valueOf(prim) {
  return prim.valueOf();
}

function toJson(prim) {
  return prim.toJson();
}

export {
  Unknown_error,
  Div_by_zero,
  Invalid_number,
  Invalid_decimal_places,
  Invalid_rounding_mode,
  No_square_root,
  Invalid_precision,
  fromString,
  fromFloat,
  fromInt,
  setDP,
  setRM,
  setNE,
  setPE,
  getDP,
  getRM,
  getNE,
  getPE,
  abs,
  cmp,
  div,
  eq,
  gt,
  gte,
  lt,
  lte,
  minus,
  mod_,
  plus,
  pow,
  round,
  sqrt,
  times,
  toExponential,
  toFixed,
  toPrecision,
  toString,
  valueOf,
  toJson,
  c,
  e,
  s,
}
/* bigJsObj Not a pure module */
